import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetResource({ commit }, data) {
    commit(types.RESET_RESOURCE, data)
  },
  setResourceData({ commit }, data) {
    commit(types.SET_RESOURCE_DATA, data)
  },
  async getLibraryName({ commit }, id) {
    const r = await http.get(`v2/resources/libraryname/${id}`)
    commit(types.SET_LIBRARYNAME, r.data.data)
    return r.data.data
  },
  async getResources({ commit }, data) {
    const r = await http.get(`v2/resources`, {
      params: data,
    })
    commit(types.SET_RESOURCES, r.data.data)
    return r.data.data
  },
  async editResource({ commit }, data) {
    commit(types.SET_RESOURCE, data)
  },
  async getResource({ commit }, id) {
    const r = await http.get(`v2/resources/${id}`)
    commit(types.SET_RESOURCE, r.data.data)
    return r.data.data
  },
  async saveResource({ commit }, data) {
    let r = null
    r = await http.post('v2/resources', data)
    return r.data.data
  },
  async removeResource({ commit }, data) {
    const r = await http.post(`v2/resources/delete`, data)
    return r.data.data
  },
  async savePriorities({ commit }, data) {
    const r = await http.post(`v2/resources/priorities`, data)
    return r.data.data
  },
}
